<template>

  <div class="has-text-centered">
    <button @click="gallery()" class="button">View Galleries</button>
    <button @click="refresh()" class="button">Refresh Galleries</button>
    <h1>{{info.data}}</h1>
  </div>

</template>

<script>
import axios from 'axios';
import { setInterval } from 'timers';

export default {
  name: 'admin-gallery',
  data() {
    return {
      info: '',
    };
  },
  methods: {
    refresh() {
      axios.get('http://localhost/api/gallery/flickr/update').then((response) => {
        this.info = response;
      });
    },
    gallery() {
      this.$router.push('/weddings-&-events');
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/AdminGallery.vue